import * as t from "io-ts";
import { MaybeExportedTreeV } from "./tree";

export const GlobalBlockV = t.intersection([
  t.type({
    label: t.string,
    id: t.number, // can be -1 when creating a new post
    tree: MaybeExportedTreeV,
    editInBreakdanceLink: t.string
  }),
  t.partial({
    status: t.union([t.literal("publish"), t.literal("trash")])
  })
]);

export type GlobalBlock = t.TypeOf<typeof GlobalBlockV>;

export const GlobalBlocksV = t.array(GlobalBlockV);
